module.exports = __webpack_public_path__ + "img/Layer_11.38e9a0da.png";